require('./taxAdditionalCountryData.scss');
const PropTypes = require('prop-types');
// vendors
const React = require('react');
// constants
const { getTranslatedCountry } = require('constants/countries');
const TAXING_REASON = require('constants/taxingReason');
const { DEFAULT_DOCUMENT_TYPE } = require('constants/index');
import { validateTin } from 'actions/tinValidation';
// components
const Highlighted = require('components/commons/highlighted/highlighted');

class TaxAdditionalCountryData extends React.Component {
    state = {
        validTin: true
    }

    async componentDidMount() {
        const { immCountry } = this.props;
        const tincodeString = immCountry.get('tin').get('codigodocumpersonacorp') ? immCountry.get('tin').get('codigodocumpersonacorp').trim() : '';
        const validTin = await validateTin(immCountry.get('paisTributacion'), tincodeString)
        
        // eslint-disable-next-line react/no-did-mount-set-state
        this.setState({ validTin });
    }

    
    buildHighlighted(content, isHighlighted) {
        return (<Highlighted isHighlighted={isHighlighted}>{content}</Highlighted>);
    }

    render() {
        const { immCountry, className } = this.props;
        const indTipoTributacion = immCountry.get('indTipoTributacion');
        let countryString, taxString, tinString, tincodeString, content;
        const highlighted = (immCountry.get('highlight') !== undefined) ? immCountry.get('highlight').toJS() : null;
        countryString = getTranslatedCountry(immCountry.get('paisTributacion'));
        taxString = indTipoTributacion ? ", " + TAXING_REASON()[indTipoTributacion ? indTipoTributacion.trim() : ''] + "." : ".";
        tinString = DEFAULT_DOCUMENT_TYPE;
        tincodeString = immCountry.get('tin').get('codigodocumpersonacorp') ? immCountry.get('tin').get('codigodocumpersonacorp').trim() : '';

        if (highlighted) {
            content = (
                <span>
                    {this.buildHighlighted(countryString, highlighted.paisTributacion)},&nbsp;
                    {this.buildHighlighted(taxString, highlighted.indTipoTributacion)}.&nbsp;
                    {tinString}:&nbsp;{this.buildHighlighted(tincodeString, highlighted.codigodocumpersonacorp)}
                </span>
            );
        } else {
            content = `${countryString}${taxString} ${tinString}: ${tincodeString}`;
        }

        if (countryString) {
            return (
                <span className={this.state.validTin ? className : 'invalid-tin'}>
                    {content}
                </span>
            )
        } else {
            return (
                <span className={className}>{''}</span>
            )
        }

    }
}

TaxAdditionalCountryData.propTypes = {
    className: PropTypes.string,
    immCountry: PropTypes.object
};

module.exports = TaxAdditionalCountryData;